import {executeGetJsonStreamRequest} from "./AxiosClient";

export const fetchActive = () => {
    return executeGetJsonStreamRequest("/partnership/active");
};
